import React from 'react';
import { Instagram, Linkedin, Github } from 'lucide-react';
import { Link } from 'react-router-dom';

const FooterSection: React.FC = () => {
  return (
    <footer className="bg-black text-white pt-16 pb-8 px-4 sm:px-8 lg:px-24" data-bg="dark">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <h2 className="text-3xl font-bold">Manish Shrestha</h2>
            <p className="text-sm opacity-75 mt-2 text-center md:text-left">© {new Date().getFullYear()} All rights reserved.</p>
          </div>
          
          <div className="flex space-x-6">
            <a href="https://www.instagram.com/_manish.shrestha/?hl=en" className="opacity-75 hover:opacity-100 transition-opacity">
              <Instagram size={20} />
            </a>
            <a href="https://www.linkedin.com/in/manish-shrestha-3b03291b4/" className="opacity-75 hover:opacity-100 transition-opacity">
              <Linkedin size={20} />
            </a>
            <a href="https://github.com/manish-shre" className="opacity-75 hover:opacity-100 transition-opacity">
              <Github size={20} />
            </a>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <nav className="flex flex-wrap justify-center md:justify-start gap-6 mb-6 md:mb-0">
              <Link to="/work" className="text-sm opacity-75 hover:opacity-100 transition-opacity">Work</Link>
              <Link to="/background" className="text-sm opacity-75 hover:opacity-100 transition-opacity">Background</Link>
              <Link to="/About" className="text-sm opacity-75 hover:opacity-100 transition-opacity">About</Link>
            </nav>
            
            <a href="mailto:hello@example.com" className="text-sm underline-animation">manishstha2017@gmail.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;